import actions from './actions';

const initState = {
  loading: false,
  messages: null,
  buttonLoading: false,
  error: null,
  totalAllAgentsData: [],
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_AllAGENTS_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_AllAGENTS_DATA_SUCCESS:
      console.log("Reducer payload data:", action.payload.data);

      return {
        ...state,
        loading: false,
        totalAllAgentsData: action.payload.data, // The array of agents
      };
    case actions.GET_ALLAGENTS_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

       case actions.ADD_AGENTS:
      return {
        ...state,
        buttonLoading: true,
      };
    case actions.ADD_AGENTS_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        messages: action.payload.message,
        totalAllAgentsData: [...state.totalAllAgentsData, action.payload.data],
        error: null,
      };
    case actions.ADD_AGENTS_FAILED:
      return {
        ...state,
        buttonLoading: false,
        error: action.payload.error,
      };
        case actions.UPDATE_AGENT_DETAIL:
      return {
        ...state,
        buttonLoading: true,
      };
    case actions.UPDATE_AGENT_DETAIL_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        messages: action.payload.message,
        totalAllAgentsData: state.totalAllAgentsData.map(agent => 
          agent.agentId === action.payload.agentId
            ? { ...agent, ...action.payload.updatedData }
            : agent
        ),
        error: null,
      };
    case actions.UPDATE_AGENT_DETAIL_FAILED:
      return {
        ...state,
        buttonLoading: false,
        error: action.payload.error,
      };

      return {
        ...state,
        buttonLoading: false,
        error: action.payload.error,
        messages: null,
      };
    default:
      return state;
  }

}